import { TStateUpdateErrorUK } from '../../types';

const tryParsePointer = (message?: string): string | undefined => {
  if (!message) return undefined;
  try {
    return JSON.parse(message)?.errors?.[0]?.source?.pointer;
  } catch {
    return undefined;
  }
};

export const parseErrorMessageFromPointerUK = (
  error: Error,
): TStateUpdateErrorUK => {
  const pointer = tryParsePointer(error?.message);

  if (!pointer) {
    return 'other';
  }

  // Step 0 fields
  if (pointer.includes('email')) {
    return 'What is your business email address?';
  }

  // Company details fields
  if (
    pointer.includes('company_number') ||
    pointer.includes('registered_company_name') ||
    pointer.includes('type') ||
    pointer.includes('trading_from_date')
  ) {
    return 'Limited company';
  }

  if (pointer.includes('website')) {
    return 'Website';
  }

  if (pointer.includes('last_12_months_turnover')) {
    return 'Last 12 months’ turnover';
  }

  if (pointer.includes('vat_status')) {
    return 'Is the business VAT registered?';
  }

  // Personal details fields
  if (
    pointer.includes('title') ||
    pointer.includes('first_name') ||
    pointer.includes('last_name')
  ) {
    return 'Full name';
  }

  if (pointer.includes('date_of_birth')) {
    return 'Date of birth';
  }

  if (pointer.includes('phones')) {
    return 'Main phone number';
  }

  if (pointer.includes('residential_addresses')) {
    return 'Home address';
  }

  if (pointer.includes('privacy_policy')) {
    return 'I’ve read and agreed to all terms & conditions';
  }

  return 'other';
};
